import z from "../../../zod";

export const Realm = z.enum(["Primary", "Aurora"]);
export const Credential = z.enum(["OTP", "WebAuthn"]);
export const KeycloakUserReference = z.object({
  realm: z.string(), // This is the actual realm name, not our Realm type!
  email: z.string(),
});

export const ResetCredential = z.object({
  credential: Credential,
  realm: Realm,
});

export const DirectGrantAuthorisation = z.object({
  email: z.string().email().min(1),
  password: z.string().min(1),
});

export const OAuth2Authorisation = z.object({
  code: z.string().min(1),
  redirectUri: z.string().url().min(1),
});

export const PrivilegedAuthorisation = z.object({
  email: z.string().email().min(1),
});

export const RequestToken = z.object({
  requestToken: z.string().min(1),
});

export const PrivilegedRequestToken = RequestToken.extend({
  confirmToken: z.string().min(1),
});
